window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="hidden";
 sizemsg.style.visibility="hidden";
 linkmsg.innerHTML="カラーを選択してください";
}

//画像変更
function shapeType(changeImg){
  var imgSrc = $(document.area1).attr('src').split('/');    
  var select_board = imgSrc[10].replace("cl_","").replace("sq_","").replace("sqr_","");
    
  switch(changeImg){
    case 0:var shapeChange = $(document.area1).attr('src').replace(imgSrc[10] , "cl_" + select_board);break;
    case 1:var shapeChange = $(document.area1).attr('src').replace(imgSrc[10] , "sq_" + select_board);break;
    case 2:var shapeChange = $(document.area1).attr('src').replace(imgSrc[10] , "sqr_" + select_board);break;
  }
    $(document.area1).attr('src', shapeChange);
}
function topBoard(changeImg){
  var imgSrc = $(document.area1).attr('src').split('/');
  var select_type = imgSrc[10].split('_');
  
  switch(changeImg){
    case 0:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_br");break;
    case 1:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_tk");break;
    case 2:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_whw");break;
    case 3:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_dbr");break;
    case 4:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_nt");break;
    case 5:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_oak");break;
    case 6:var materialChange = $(document.area1).attr('src').replace(imgSrc[10] , select_type[0] + "_baltable_bkw");break;
  }
    $(document.area1).attr('src', materialChange+".png");
}
function legType(changeImg){
  var imgSrc = $(document.area2).attr('src').split('/');  
  switch(changeImg){
    case 0:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_br");break;
    case 1:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_tk");break;
    case 2:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_whw");break;
    case 3:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_dbr");break;
    case 4:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_nt");break;
    case 5:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_oak");break;
    case 6:var materialChange = $(document.area2).attr('src').replace(imgSrc[10] , "leg_baltable_bkw");break;
  }
    $(document.area2).attr('src', materialChange+".png");
}


/*内容リセット*/
function cartReset(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_height.innerHTML="";
 cart_color.innerHTML="";
 cart_leg.innerHTML="";
 cart_option.innerHTML="";
 linkmsg.style.visibility="hidden";
}


function changeMsg(){
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;  
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intHaba < 55 || intHaba > 90){document.getElementById("sizemsg").innerHTML = "<p>※ 幅55cm未満・幅90cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 70 || intHeight > 120){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ70cm未満・高さ120cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
 sizemsg.style.visibility="hidden";
}


const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,option,haba,height,color){
this.url=url;this.option=option;this.haba=haba;this.height=height;this.color=color;}
function searchURL(strOption,strHaba,strHeight,strColor){
var strErr;
var intHeight=document.getElementById("height").value;
var intHaba=document.getElementById("haba").value;
intHeight=parseInt(intHeight);
intHaba=parseInt(intHaba);

//幅・奥行チェック
if (intHaba < 55){
 strErr="幅55cm未満";
}else if (intHaba > 90){
  strErr="幅91cm以上";
}
//高さチェック
if (intHeight < 70){
 strErr="高さ70cm未満";
}else if (intHeight > 120){
  strErr="高さ121cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}

//ベース価格
var basePriceWD = [43000,61000,63000,65000];
var basePriceMM1 = [43000,61000,63000,65000];
var basePriceMM2 = [43000,61000,63000,65000];
var basePriceMM3 = [43000,61000,63000,65000];
var addPrice = [3000,4000];
var sellPrice;

if(strHaba <= 60){//▼幅60cm未満の場合▼
  if(strHeight == 70){//高さ70cmの場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]; }
    else if(strColor == "nail" || strColor == "black"){ sellPrice = basePriceMM1[0];}
    else if(strColor == "bp"){ sellPrice = basePriceMM2[0];}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){ sellPrice = basePriceMM3[0];}
  }
  else if(strHeight <= 80){//高さ80cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]+(addPrice[0]*1);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[0]+(addPrice[0]*1);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[0]+(addPrice[0]*1);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[0]+(addPrice[0]*1);}
  }
  else if(strHeight <= 90){//高さ90cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]+(addPrice[0]*2);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[0]+(addPrice[0]*2);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[0]+(addPrice[0]*2);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[0]+(addPrice[0]*2);}
  }
  else if(strHeight <= 100){//高さ100cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]+(addPrice[0]*3);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[0]+(addPrice[0]*3);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[0]+(addPrice[0]*3);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[0]+(addPrice[0]*3);}
  }
  else if(strHeight <= 110){//高さ110cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]+(addPrice[0]*4);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[0]+(addPrice[0]*4);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[0]+(addPrice[0]*4);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[0]+(addPrice[0]*4);}
  }
  else if(strHeight <= 120){//高さ120cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[0]+(addPrice[0]*5);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[0]+(addPrice[0]*5);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[0]+(addPrice[0]*5);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[0]+(addPrice[0]*5);}
  }
}

else if(strHaba <= 70){//▼幅70cm未満の場合▼
  if(strHeight == 70){//高さ70cmの場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]; }
    else if(strColor == "nail" || strColor == "black"){ sellPrice = basePriceMM1[1];}
    else if(strColor == "bp"){ sellPrice = basePriceMM2[1];}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){ sellPrice = basePriceMM3[1];}
  }
  else if(strHeight <= 80){//高さ80cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]+(addPrice[0]*1);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[1]+(addPrice[0]*1);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[1]+(addPrice[0]*1);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[1]+(addPrice[0]*1);}
  }
  else if(strHeight <= 90){//高さ90cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]+(addPrice[0]*2);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[1]+(addPrice[0]*2);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[1]+(addPrice[0]*2);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[1]+(addPrice[0]*2);}
  }
  else if(strHeight <= 100){//高さ100cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]+(addPrice[0]*3);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[1]+(addPrice[0]*3);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[1]+(addPrice[0]*3);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[1]+(addPrice[0]*3);}
  }
  else if(strHeight <= 110){//高さ110cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]+(addPrice[0]*4);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[1]+(addPrice[0]*4);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[1]+(addPrice[0]*4);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[1]+(addPrice[0]*4);}
  }
  else if(strHeight <= 120){//高さ120cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[1]+(addPrice[0]*5);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[1]+(addPrice[0]*5);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[1]+(addPrice[0]*5);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[1]+(addPrice[0]*5);}
  }
}

else if(strHaba <= 80){//▼幅80cm未満の場合▼
  if(strHeight == 70){//高さ70cmの場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]; }
    else if(strColor == "nail" || strColor == "black"){ sellPrice = basePriceMM1[2];}
    else if(strColor == "bp"){ sellPrice = basePriceMM2[2];}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){ sellPrice = basePriceMM3[2];}
  }
  else if(strHeight <= 80){//高さ80cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]+(addPrice[0]*1);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[2]+(addPrice[0]*1);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[2]+(addPrice[0]*1);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[2]+(addPrice[0]*1);}
  }
  else if(strHeight <= 90){//高さ90cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]+(addPrice[0]*2);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[2]+(addPrice[0]*2);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[2]+(addPrice[0]*2);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[2]+(addPrice[0]*2);}
  }
  else if(strHeight <= 100){//高さ100cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]+(addPrice[0]*3);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[2]+(addPrice[0]*3);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[2]+(addPrice[0]*3);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[2]+(addPrice[0]*3);}
  }
  else if(strHeight <= 110){//高さ110cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]+(addPrice[0]*4);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[2]+(addPrice[0]*4);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[2]+(addPrice[0]*4);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[2]+(addPrice[0]*4);}
  }
  else if(strHeight <= 120){//高さ120cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[2]+(addPrice[0]*5);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[2]+(addPrice[0]*5);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[2]+(addPrice[0]*5);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[2]+(addPrice[0]*5);}
  }
}

else if(strHaba <= 90){//▼幅90cm未満の場合▼
  if(strHeight == 70){//高さ70cmの場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]; }
    else if(strColor == "nail" || strColor == "black"){ sellPrice = basePriceMM1[3];}
    else if(strColor == "bp"){ sellPrice = basePriceMM2[3];}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){ sellPrice = basePriceMM3[3];}
  }
  else if(strHeight <= 80){//高さ80cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]+(addPrice[0]*1);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[3]+(addPrice[0]*1);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[3]+(addPrice[0]*1);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[3]+(addPrice[0]*1);}
  }
  else if(strHeight <= 90){//高さ90cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]+(addPrice[0]*2);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[3]+(addPrice[0]*2);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[3]+(addPrice[0]*2);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[3]+(addPrice[0]*2);}
  }
  else if(strHeight <= 100){//高さ100cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]+(addPrice[0]*3);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[3]+(addPrice[0]*3);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[3]+(addPrice[0]*3);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[3]+(addPrice[0]*3);}
  }
  else if(strHeight <= 110){//高さ110cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]+(addPrice[0]*4);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[3]+(addPrice[0]*4);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[3]+(addPrice[0]*4);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[3]+(addPrice[0]*4);}
  }
  else if(strHeight <= 120){//高さ120cm未満の場合
    if(strColor=="wood"){sellPrice = basePriceWD[3]+(addPrice[0]*5);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceMM1[3]+(addPrice[0]*5);}
    else if(strColor == "bp"){sellPrice = basePriceMM2[3]+(addPrice[0]*5);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceMM3[3]+(addPrice[0]*5);}
  }
}


  return sellPrice;
}
/*リストから商品URLを取得*/
function checkURL(strOption,strHaba,strHeight,strColor){
  for(var i in goods){
if(goods[i].option==strOption && goods[i].haba==strHaba && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 cartReset()
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strHeight=document.getElementById("height").value;
var strHaba=document.getElementById("haba").value;
var idColor = document.getElementsByName( "colortype" );
var idLeg = document.getElementsByName( "colorleg" );
var idOption = document.getElementsByName( "option" );
var strColor = "";
var strLeg = "";
var strOption = "";
var i=0;
var c=0;
var n=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}
for ( strLeg="", n=idLeg.length; n--; ) {
 if ( idLeg[n].checked ) {
     if( idLeg[n].id.slice(0,3)=="leg" ){
         strLeg = idLeg[n].id.slice(0,3);
     }else{
         strLeg = idLeg[n].id;
     }
  var valueLeg = idLeg[n].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("天板カラーを選択してください");
return false;
}
if (strLeg==false){
alert("脚カラーを選択してください");
return false;
}



document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strHeight+"cm"
document.getElementById("choice3").value=valueColor
document.getElementById("choice6").value=valueLeg
document.getElementById("choice4").value=valueOption

//商品ページの有無チェック
var comcode=checkURL(strOption,strHaba,strHeight,strColor);

if(valueColor=="オーク" || valueColor=="ブラックウッド"){
  if (!comcode=="" && valueColor==valueLeg){
    var target=document.getElementById("linkmsg");
    linkmsg.style.visibility="visible";
    target.innerHTML= valueColor + "は別注色のため金額が異なります。";
  }
}
else if(!comcode=="" && valueColor==valueLeg){
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
}

var url=searchURL(strOption,strHaba,strHeight,strColor);

if(!url){
alert("幅を入力してください");
return false;
}

var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
 cart_leg.innerHTML=valueLeg;
 cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice5").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice6=document.frm.choice6.value;
 var choice4=document.frm.choice4.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }
    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a52892","rnd","60","70","wood");
goods[1] =new setGoods("0000a52897","rnd","70","70","wood");
goods[2] =new setGoods("0000a52902","rnd","80","70","wood");
goods[3] =new setGoods("0000a52907","rnd","90","70","wood");
goods[4] =new setGoods("0000a52912","rnd","60","90","wood");
goods[5] =new setGoods("0000a52917","rnd","70","90","wood");
goods[6] =new setGoods("0000a52922","rnd","80","90","wood");
goods[7] =new setGoods("0000a52927","rnd","90","90","wood");
goods[8] =new setGoods("0000a52932","rnd","60","110","wood");
goods[9] =new setGoods("0000a52937","rnd","70","110","wood");
goods[10] =new setGoods("0000a52942","rnd","80","110","wood");
goods[11] =new setGoods("0000a52947","rnd","90","110","wood");
goods[12] =new setGoods("0000a52952","sqr","60","70","wood");
goods[13] =new setGoods("0000a52957","sqr","70","70","wood");
goods[14] =new setGoods("0000a52962","sqr","80","70","wood");
goods[15] =new setGoods("0000a52967","sqr","90","70","wood");
goods[16] =new setGoods("0000a52972","sqr","60","90","wood");
goods[17] =new setGoods("0000a52977","sqr","70","90","wood");
goods[18] =new setGoods("0000a52982","sqr","80","90","wood");
goods[19] =new setGoods("0000a52987","sqr","90","90","wood");
goods[20] =new setGoods("0000a52992","sqr","60","110","wood");
goods[21] =new setGoods("0000a52997","sqr","70","110","wood");
goods[22] =new setGoods("0000a53002","sqr","80","110","wood");
goods[23] =new setGoods("0000a53007","sqr","90","110","wood");
goods[24] =new setGoods("0000a53012","rw","60","70","wood");
goods[25] =new setGoods("0000a53017","rw","70","70","wood");
goods[26] =new setGoods("0000a53022","rw","80","70","wood");
goods[27] =new setGoods("0000a53027","rw","90","70","wood");
goods[28] =new setGoods("0000a53032","rw","60","90","wood");
goods[29] =new setGoods("0000a53037","rw","70","90","wood");
goods[30] =new setGoods("0000a53042","rw","80","90","wood");
goods[31] =new setGoods("0000a53047","rw","90","90","wood");
goods[32] =new setGoods("0000a53052","rw","60","110","wood");
goods[33] =new setGoods("0000a53057","rw","70","110","wood");
goods[34] =new setGoods("0000a53062","rw","80","110","wood");
goods[35] =new setGoods("0000a53067","rw","90","110","wood");









